export const XERO_FAQ_LINK =
  ' https://help.omnipresent.com/en/articles/10547353-integrating-xero-with-the-omni-platform-faq';
export const XERO_GUIDE_LINK =
  'https://help.omnipresent.com/en/articles/10547460-how-to-setup-and-manage-your-xero-integration-guide';
